import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-zinc-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-184" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-185" data-mp="o3xb3cmzv1ct">
        <SectionHeading id="summary-title" data-id="element-186" data-mp="j887my7ut0b8">Everything <span className="text-orange-400" data-id="element-187" data-mp="j5c7r4cg41k5">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-teal-700/60 bg-zinc-900 sm:grid-cols-2" data-id="element-188" data-mp="1gu5tn5lfznrx">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-teal-700/15 p-4 sm:odd:border-r" data-id="element-189" data-mp="16whodlq7mxvi">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-400 shadow-[0_0_10px_rgba(45,212,191,0.6)]" data-id="element-190" data-mp="12vxnc72ina43">
                <CheckIcon className="h-3.5 w-3.5 text-zinc-950" aria-hidden="true" data-id="element-191" data-mp="3rknhvtqehifk" />
              </span>
              <b className="text-sm text-white" data-id="element-192" data-mp="3nnrffsn0d79q">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}